import React from 'react';
import {ConditionalRenderer} from "./ConditionalRenderer";

interface CheckBoxProps {
    onChange: Function;
    checked: boolean;
    id: string;
    disabled?: boolean;
    inactive?: boolean;
    label?: string;
    sublabel?: string;
}

export let CheckBox = function (props: CheckBoxProps) {
    function onChange() {
        props.onChange(!props.checked);
    }

    let idProps = {id: ''};
    if (props.id) {
        idProps.id = props.id;
    }

    return (
        <div
            {...idProps}
            className={`checkbox-container ${props.disabled ? 'disabled' : ''}`}
            onClick={props.disabled ? () => null : onChange}
        >
            <div
                className="common-form-checkbox"
            >
                {(() => {
                    if (props.checked) {
                        return (
                            <div className="common-form-checkbox-check"/>
                        )
                    }
                })()}
            </div>
            <ConditionalRenderer if={props.label} renderer={() => (
                <div className={`checkbox-label ${props.inactive ? 'inactive' : ''}`}>{props.label}</div>
            )}/>
            <ConditionalRenderer if={(props.disabled && props.sublabel)} renderer={() => (
                <div className="checkbox-disabled-sublabel">{`(${props.sublabel})`}</div>
            )}/>
        </div>
    );
};
